import { Form, FormItemProps, FormProps } from 'antd';
import clsx from 'clsx';
import { AntButton } from 'components/ant/AntButton/AntButton';
import { AntButtonProps } from 'components/ant/AntButton/AntButton.types';
import { Modal as UIModal, ModalProps } from 'components/UI/Modal/styled';
import React from 'react';

import s from './Mailer.module.less';

const { Item } = Form;

export const Modal: React.FC<ModalProps> = ({ className, ...rest }) => (
  <UIModal {...rest} className={clsx(s.modal, className)} />
);

export const RecipientItem: React.FC<FormItemProps> = ({ className, ...rest }) => (
  <Item {...rest} className={clsx(s.recipientItem, className)} layout="horizontal" />
);

export const MailerFormGroup: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.mailerFormGroup, className)} />
);

export const ScreenContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.screenContainer, className)} />
);

interface InnerProps extends React.HTMLAttributes<HTMLDivElement> {
  success?: boolean;
  failure?: boolean;
}

export const Inner: React.FC<InnerProps> = ({ className, success, failure, ...rest }) => (
  <div {...rest} className={clsx(s.inner, { [s.success]: success, [s.failure]: failure }, className)} />
);

export const Container: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.container, className)} />
);

export const Overlay: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.overlay, className)} />
);

export const ProcessText: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.processText, className)} />
);

export const SendDirectEmailButton: React.FC<AntButtonProps> = ({ className, ...rest }) => (
  <AntButton {...rest} className={clsx(s.sendDirectEmailButton, className)} />
);

export const StyledForm = ({ className, children, ...rest }: FormProps): React.ReactElement => (
  <Form {...rest} className={clsx(s.styledForm, className)}>
    {children as React.ReactNode}
  </Form>
);

export const StyledTextAreaItem: React.FC<FormItemProps> = ({ className, ...rest }) => (
  <Item {...rest} className={clsx(s.styledTextAreaItem, className)} />
);
